// src/components/AdminLayout.js
import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { styled } from '@mui/material/styles';

const EXPANDED_WIDTH = 280;
const COLLAPSED_WIDTH = 64;

const LayoutContainer = styled('div')`
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-primary);
`;

const MainContent = styled('main')`
  flex: 1;
  margin-left: ${props => props.collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH}px;
  margin-top: 80px;
  padding: var(--space-lg);
  min-height: calc(100vh - 80px);
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
  position: relative;
  overflow-x: auto;
  transition: margin-left var(--transition-normal);

  @media (max-width: 768px) {
    margin-left: 0;
    padding: var(--space-md);
  }

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(ellipse at top, rgba(16, 185, 129, 0.05) 0%, transparent 70%);
    pointer-events: none;
    z-index: -1;
  }
`;

const ContentWrapper = styled('div')`
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

function AdminLayout({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem("sidebar_collapsed") === "true";
  });

  const handleToggle = () => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem("sidebar_collapsed", next);
      return next;
    });
  };

  return (
    <LayoutContainer>
      <Navbar />
      <Sidebar collapsed={collapsed} onToggle={handleToggle} />
      <MainContent collapsed={collapsed}>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </MainContent>
    </LayoutContainer>
  );
}

export default AdminLayout;
